let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kW5ll")).then(() => parcelRequire('8u6tU'));